import { useEffect, useState } from "react";
import userImage from '../img/user_image.png'
import '../css/user_images_container.css'


function UserImagesContainer({images, userImage, activeImageId, setActiveImageId}) {

    useEffect(() => {
        if (userImage){
            setActiveImageId(userImage.id)
        }
    }, [userImage])

    const chunkArray = (arr, size) => {
            const chunks = [];
            for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
            }
            return chunks;
        };

    const groupedImages = chunkArray(images, 3);

    return <div className="user-images-container">
        {groupedImages.map((group, groupIndex) => (
        <div key={groupIndex} className="user-images-row">
          {group.map((image, imageIndex) => (
            <div key={imageIndex} className={image.id === activeImageId ? "user-image-container active-user-image-container" : "user-image-container"} onClick={() => {
                if (image.id !== activeImageId) {
                setActiveImageId(image.id)
                }
                else {
                    setActiveImageId(null)
                }
            }}>
                <img className="user-image" alt='error' src={image.image}/>
            </div>
          ))}
        </div>
      ))}
      <div className="user-images-breakline"/>
    </div>
};

export default UserImagesContainer;